// extracted by mini-css-extract-plugin
export default {"Offcanvas":"FeatureModule_Offcanvas__yM5t6"};